import { useSendRobotCommand } from 'lib/handlers/robot-command';

import { useGripperHoldingItem, useGripperOpeningPercentage } from './getters';

export function useOpenCloseGripper() {
  const { openingPercentage } = useGripperOpeningPercentage();
  const { gripperHoldingItem } = useGripperHoldingItem();

  // for sending the command only
  const { sendGripperCommand, sendArmStopCommand, loading, result } = useSendRobotCommand();

  async function handleOpenGripper(slow = false) {
    return sendGripperCommand(true, slow);
  }

  function handleCloseGripper(slow = false) {
    return sendGripperCommand(false, slow);
  }

  return {
    loading,
    result,
    gripperHoldingItem,
    openingPercentage,
    handleOpenGripper,
    handleCloseGripper,
    sendArmStopCommand,
  };
}
